"use client";

import dynamic from "next/dynamic";
import type { ComponentProps } from "react";
import { Suspense } from "react";

const SplinePlayer = dynamic(
  async () => {
    const mod = await import("@splinetool/react-spline");
    return mod.default;
  },
  {
    ssr: false,
  }
);

export interface LazySplineProps extends ComponentProps<typeof SplinePlayer> {
  /**
   * 自定义loading占位符
   */
  placeholder?: React.ReactNode;
}

/**
 * 懒加载的Spline组件，支持SSR
 */
export function LazySpline({ placeholder, ...props }: LazySplineProps) {
  const { className, style } = props;

  const defaultPlaceholder = (
    <div
      className={`${
        className ?? ""
      } bg-[radial-gradient(circle,_rgba(82,81,246,0.25)_0%,_rgba(255,255,255,0)_65%)]`}
      style={style}
      aria-hidden
    />
  );

  return (
    <Suspense fallback={placeholder ?? defaultPlaceholder}>
      <SplinePlayer {...props} />
    </Suspense>
  );
}
